import { NewFilterOption } from '@/components/FilterNew/types';

// type Params = NonNullable<
//   ReturnType<typeof usePaginatedgetLabelCategoriesQuery>[0]
// >[0];

export const getLabelCategoryOption = (labelCategory: any): NewFilterOption => {
  return {
    value: labelCategory.id,
    label: labelCategory.name,
    item: labelCategory,
  };
};
